export default {
  /* Load dashboard from LocalStorage */
  DASHBOARD_LOAD_ITEMS: 'DASHBOARD_LOAD_ITEMS',
  DASHBOARD_LOAD_ITEMS_ERROR: 'DASHBOARD_LOAD_ITEMS_ERROR',
  DASHBOARD_INSERT_ITEMS: 'DASHBOARD_INSERT_ITEMS',
  DASHBOARD_INSERT_DATES: 'DASHBOARD_INSERT_DATES',
  DASHBOARD_INSERT_ITEMS_DATES: 'DASHBOARD_INSERT_ITEMS_DATES',//
  DASHBOARD_INSERT_ITEMS_INTERVAL: 'DASHBOARD_INSERT_ITEMS_INTERVAL',
  DASHBOARD_INSERT_ITEMS_FILTER: 'DASHBOARD_INSERT_ITEMS_FILTER',

  /* Items initialization */
  DASHBOARD_INIT_ITEMS: 'DASHBOARD_INIT_ITEMS',
  DASHBOARD_INIT_ITEMS_ERROR: 'DASHBOARD_INIT_ITEMS_ERROR',

  /* Clean */
  DASHBOARD_CLEAN_ITEMS: 'DASHBOARD_CLEAN_ITEMS',

  /* Items update */
  DASHBOARD_UPDATE_ITEMS: 'DASHBOARD_UPDATE_ITEMS',

  /* Multi items support */
  DASHBOARD_ADD_ITEM: 'DASHBOARD_ADD_ITEM',
  DASHBOARD_REMOVE_ITEM: 'DASHBOARD_REMOVE_ITEM',

  /* Costs values */
  DASHBOARD_GET_VALUES: 'DASHBOARD_GET_VALUES',
  DASHBOARD_GET_VALUES_SUCCESS: 'DASHBOARD_GET_VALUES_SUCCESS',
  DASHBOARD_GET_VALUES_ERROR: 'DASHBOARD_GET_VALUES_ERROR',

  /* Dates */
  DASHBOARD_SET_DATES: 'DASHBOARD_SET_DATES',
  DASHBOARD_RESET_DATES: 'DASHBOARD_RESET_DATES',
  DASHBOARD_CLEAR_DATES: 'DASHBOARD_CLEAR_DATES',
  DASHBOARD_SET_ITEM_DATES: 'DASHBOARD_SET_ITEM_DATES',//
  DASHBOARD_RESET_ITEMS_DATES: 'DASHBOARD_RESET_ITEMS_DATES',//
  DASHBOARD_CLEAR_ITEMS_DATES: 'DASHBOARD_CLEAR_ITEMS_DATES',//

  /* Intervals */
  DASHBOARD_SET_ITEM_INTERVAL: 'DASHBOARD_SET_ITEM_INTERVAL',
  DASHBOARD_RESET_ITEMS_INTERVAL: 'DASHBOARD_RESET_ITEMS_INTERVAL',
  DASHBOARD_CLEAR_ITEMS_INTERVAL: 'DASHBOARD_CLEAR_ITEMS_INTERVAL',

  /* Filters */
  DASHBOARD_SET_ITEM_FILTER: 'DASHBOARD_SET_ITEM_FILTER',
  DASHBOARD_RESET_ITEMS_FILTER: 'DASHBOARD_RESET_ITEMS_FILTER',
  DASHBOARD_CLEAR_ITEMS_FILTER: 'DASHBOARD_CLEAR_ITEMS_FILTER'
};



// WEBPACK FOOTER //
// ./src/constants/dashboardTypes.js